// removed by extract-text-webpack-plugin
module.exports = {"root":"f9b2a7bf","input":"_1b1ad9a0","label":"b4315530","checker":"_2aaeb584","checked":"_3db5662e","unchecked":"aab8414f"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/PickList/index.styl
// module id = 2280
// module chunks = 39